import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ApplicationStatus {
  status: string;
  showResult: boolean;
  expiresAt: string;
  productAccountUUID: string;
  showCounterOffer: boolean;
  rejectionReasonsURL: string;
  frozenExpiresAt: string;
  applicationUUID: string;
  reApplicationInApp: boolean; // reApplicationInapp: reapply after getting evaluation result
  evaluationRejectReapply: boolean;
}

const initialState: ApplicationStatus = {
  status: '',
  showResult: false,
  expiresAt: '',
  productAccountUUID: '',
  showCounterOffer: false,
  rejectionReasonsURL: '',
  frozenExpiresAt: '',
  applicationUUID: '',
  reApplicationInApp: false,
  evaluationRejectReapply: false,
};

const applicationStatusSlice = createSlice({
  name: 'applicationStatus',
  initialState,
  reducers: {
    setAppStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
    },
    setShowResult: (state, action: PayloadAction<boolean | null>) => {
      state.showResult = action.payload === null ? true : action.payload;
    },
    setExpiresAt: (state, action: PayloadAction<string>) => {
      state.expiresAt = action.payload;
    },
    setProductAccountUUID: (state, action: PayloadAction<string>) => {
      state.productAccountUUID = action.payload;
    },
    setShowCounterOffer: (state, action: PayloadAction<boolean>) => {
      state.showCounterOffer = action.payload;
    },
    setRejectionReasonsURL: (state, action: PayloadAction<string>) => {
      state.rejectionReasonsURL = action.payload;
    },
    setFrozenExpiresAt: (state, action: PayloadAction<string>) => {
      state.frozenExpiresAt = action.payload;
    },
    setApplicationUUID: (state, action: PayloadAction<string>) => {
      state.applicationUUID = action.payload;
    },
    setReApplicationInApp: (state, action: PayloadAction<boolean>) => {
      state.reApplicationInApp = action.payload;
    },
    setEvaluationRejectReapply: (state, action: PayloadAction<boolean>) => {
      state.evaluationRejectReapply = action.payload;
    },
  },
});

export const {
  setAppStatus,
  setShowResult,
  setExpiresAt,
  setProductAccountUUID,
  setShowCounterOffer,
  setRejectionReasonsURL,
  setFrozenExpiresAt,
  setApplicationUUID,
  setReApplicationInApp,
  setEvaluationRejectReapply,
} = applicationStatusSlice.actions;
export default applicationStatusSlice.reducer;
